import styled from 'styled-components';

import { companyColor, defaultColor } from 'styles/theme';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ dark }) => (dark ? companyColor('font') : defaultColor('backgroundLight'))};
`;
